<template>
  <div>
    <el-dialog title="确认报名信息" :visible.sync="visible" width="90%" destroy-on-close :close-on-click-modal="false">
      <div>
        <div v-show="zphdlx == '1'">
          <moduleTitle title="岗位信息"></moduleTitle>
          <div class="post">
            <div class="column">
              <div class="header">{{ post }}</div>
              <div class="footer">
                <!-- {{ "财务共享中心 | 中心副主任 | 1人" }} -->
                {{
                    company +
                    (company ? " | " + post : "") +
                    (post ? " | " + planNumber : "") +
                    (planNumber ? "人" + "" : "")
                }}
              </div>
            </div>
          </div>
        </div>
        <moduleTitle title="报名信息"></moduleTitle>
        <div class="height">
          <!-- <resumeMessage @getid="getid"></resumeMessage> -->
          <!-- 招聘活动类型等于1，表示内部公开招聘&社会化招聘 -->
          <resumeMessageInside ref="resumeMessageInside" v-if="zplb == '3'"></resumeMessageInside>
          <!-- 招聘活动类型等于2，表示社会化招聘 -->
          <resumeMessageOutside ref="resumeMessageOutside" :data="{ zylb: post, bmbk: company }" v-if="zplb == '4'">
          </resumeMessageOutside>

          <!-- 高校毕业生招聘 -->
          <resume-message-studentside ref="resumeMessageStudentside" :data="{ zylb: post, bmbk: company, zphdid: zphdid, zplb: zplb }" v-if="zplb == '1' || zplb == '2'" />
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="save()">确认报名</el-button>
        <!-- <el-button type="primary" @click="modify()">修改简历</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" scoped>
.post {
  background-color: #f0f6fc;
  padding: 30px;
  margin: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .column {
    display: block;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .header {
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 20px;
    }

    // .footer {
    // }
  }
}

.height {
  height: 500px;
  overflow: auto;
}
</style>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
// import resumeMessage from "./resumeMessage.vue";
import resumeMessageInside from "./resumeMessageInside.vue";
import resumeMessageOutside from "./resumeMessageOutside.vue";
import resumeMessageStudentside from "./resumeMessageStudentside.vue";
import request from "@/api/postList.js";
export default {
  components: {
    moduleTitle,
    // resumeMessage,
    resumeMessageInside,
    resumeMessageOutside,
    resumeMessageStudentside,
  },
  data() {
    return {
      visible: false,
      company: "",
      post: "",
      planNumber: "",
      zphdlx: "",
      gwlbid: "",
      zphdmc: "",
      zphdid: "",
      zplb: "",
      id: ""
    };
  },
  mounted() { },
  methods: {
    /* 获取jlxxid */
    getid(data) {
      this.id = data;
    },
    show(para) {
      console.log("para", para);
      this.company = para.company;
      this.post = para.post;
      this.planNumber = para.planNumber;
      this.zphdlx = para.zphdlx;
      this.gwlbid = para.gwlbid;
      this.zphdmc = para.zphdmc;
      this.zphdid = para.zphdid;
      this.zplb = para.zplb;
      this.visible = true;
    },
    // 确认报名
    save() {
      const that = this;
      that.$confirm("请确认您所填信息正确无误，以免影响后续签约和入职", "提示").then(() => {

        // 页面组件判断用的v-if，两者有一个未undefined
        let resumeMessageInside = that.$refs.resumeMessageInside;
        let resumeMessageOutside = that.$refs.resumeMessageOutside;
        let resumeMessageStudentside = that.$refs.resumeMessageStudentside;
        let data = null; //请求需要的部分参数
        //如果resumeMessageInside不是undefined
        if (resumeMessageInside) {
          console.log("resumeMessageInside");
          if (!resumeMessageInside.validate()) {
            return;
          }
          data = resumeMessageInside.getData();
        }
        //如果resumeMessageOutside不是undefined
        if (resumeMessageOutside) {
          console.log("resumeMessageOutside");
          if (!resumeMessageOutside.validate()) {
            return;
          }
          data = resumeMessageOutside.getData();
          console.log("resumeMessageOutsidedata", data);
        }

        //如果resumeMessageStudentside不是undefined
        if (resumeMessageStudentside) {
          console.log("resumeMessageStudentside");
          if (!resumeMessageStudentside.validate()) {
            return;
          }
          data = resumeMessageStudentside.getData();
        }

        if (resumeMessageOutside) {
          let para = {
            ...data,
            jg:JSON.stringify(data.jg),
            zpqsid: that.zphdid,
            zpgwid: that.gwlbid,
            yhid: that.$store.state.userInfo.yhid
          }
          request.doSaveShhzpBmxx(para)
            .then(res => {
              console.log('传给后端信息>>>',res);
              that.visible = false;
              resumeMessageOutside.clearField();
              
              that.$message({
                message: "报名成功",
                type: "success",
                duration:1500
              });
            }).catch(err => {
              console.log(err);
            });
        } else {
          let para = {
            ...data,
            jg:JSON.stringify(data.jg),
            zphdlx: that.zphdlx,
            zphdid: that.zphdid,
            gwlbid: that.gwlbid,
            jlxxid: that.id,
            zplb: that.zplb,
            yhid: that.$store.state.userInfo.yhid
          };
          console.log('传给后端信息', para);
    
          request.doBm(para)
            .then(res => {
              console.log('传给后端信息>>>',res);
              that.visible = false;

              if (resumeMessageInside) {
                resumeMessageInside.clearField();
              } else if(resumeMessageOutside){
                resumeMessageOutside.clearField();
              } else if(resumeMessageStudentside){
                resumeMessageStudentside.clearField();
              }
              that.$message({
                message: "报名成功",
                type: "success",
                duration:1500
              });
              setTimeout(()=>{
                  let para = {
                      zphdid: that.zphdid,
                      gwlbid: that.gwlbid,
                      yhid: that.$store.state.userInfo.yhid
                  };
                  request.sendMessage(para).then(res=>{
                      console.log(res);
                  }).catch(err => {
                      console.log(err);
                  });
              },2000)
            }).catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>
